"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _line = require("cccisd-nivo/line");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var MyResponsiveLine = function MyResponsiveLine(props) {
  var _props$settings = props.settings,
    targetLineValue = _props$settings.targetLineValue,
    verticalScaleMin = _props$settings.verticalScaleMin,
    verticalScaleMax = _props$settings.verticalScaleMax,
    scoreSuffix = _props$settings.scoreSuffix,
    xLabel = _props$settings.xLabel,
    yLabel = _props$settings.yLabel,
    showLegend = _props$settings.showLegend;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      position: 'relative',
      height: '300px',
      width: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement(_line.ResponsiveLine, {
    data: props.data,
    enableSlices: "x",
    yScale: {
      type: 'linear',
      min: Number(verticalScaleMin),
      max: Number(verticalScaleMax)
    },
    axisBottom: {
      orient: 'bottom',
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      legend: xLabel,
      legendOffset: 36,
      legendPosition: 'middle'
    },
    axisLeft: {
      orient: 'left',
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      legend: yLabel,
      legendOffset: -46,
      legendPosition: 'middle',
      format: function format(n) {
        return "".concat(n).concat(scoreSuffix);
      }
    },
    markers: targetLineValue ? [{
      axis: 'y',
      value: Number(targetLineValue),
      lineStyle: {
        stroke: '#b1cbe7',
        strokeWidth: 2,
        strokeDasharray: '10,5'
      },
      legend: '',
      legendOrientation: 'horizontal'
    }] : [],
    colors: {
      scheme: 'category10'
    },
    enableGridX: true,
    layers: showLegend ? ['grid', 'markers', 'axes', 'lines', 'points', 'slices', 'mesh', 'legends'] : ['grid', 'markers', 'axes', 'lines', 'points', 'slices', 'mesh'],
    sliceTooltip: function sliceTooltip(_ref) {
      var slice = _ref.slice;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          background: 'white',
          padding: '9px 12px',
          border: '1px solid #ccc'
        }
      }, slice.points.map(function (point) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: point.id
        }, /*#__PURE__*/_react["default"].createElement("span", {
          style: {
            color: point.serieColor,
            padding: '3px 0'
          }
        }, point.serieId, ":", ' '), /*#__PURE__*/_react["default"].createElement("strong", null, point.data.yFormatted));
      }));
    }
  }));
};
var _default = exports["default"] = MyResponsiveLine;